<ng-container *ngIf="albaran$ | async as albaran">
  <perfect-scrollbar class="cliente-fecha ps--active-y">
    <ng-container *ngIf="valoresImpresion$ | async as valoresImpresion">
      {{ 'OPCIONES_DE_IMPRESION' | translateV2 : 'CAPITALIZE' }}:
      <span *ngIf="valoresImpresion.albaran"
        >{{ 'ALBARAN' | translateV2 : 'CAPITALIZE' }}
      </span>
      <span *ngIf="valoresImpresion.etiquetas"
        >{{ 'ETIQUETA' | translateV2 : 'CAPITALIZE' }}
      </span>
      <span *ngIf="valoresImpresion.factura"
        >{{ 'FACTURA' | translateV2 : 'CAPITALIZE' }}
      </span>
      <span *ngIf="valoresImpresion.entradas"
        >{{ 'ENTRADAS' | translateV2 : 'CAPITALIZE' }}
      </span>
    </ng-container>

    <span *ngIf="albaran.Localizador"> {{ albaran.Localizador }}</span>
    <span
      *ngIf="
        albaran.CodigoClienteId &&
        albaran.CodigoClienteId !== '0' &&
        albaran.NombreCliente
      "
      >{{ albaran.NombreCliente }}</span
    >
    <span *ngFor="let sesion of filtrarRecintos(albaran.AlbaranRecintos)">
      <span *ngIf="sesion.Espectaculo.length > 0">
        {{ sesion.Espectaculo }}
      </span>
      <span *ngIf="sesion.NumFila.length > 0 && sesion.NumButaca.length > 0"
        >{{ 'FILA' | translateV2 : 'CAPITALIZE' }}: {{ sesion.NumFila }}
        {{ 'BUTACA' | translateV2 : 'CAPITALIZE' }}:
        {{ sesion.NumButaca }}</span
      >
      <span *ngIf="sesion.RecintoNombre"
        >{{ sesion.RecintoNombre }} - {{ sesion.FechaEntrada }} ({{
          sesion.CantidadTotal
        }})</span
      >
    </span>
  </perfect-scrollbar>
  <fieldset>
    <div class="white-box">
      <div class="Rtable">
        <div class="Rtable-row Rtable-row--head">
          <div class="Rtable-row-inner">
            <div class="Rtable-cell item-cell column-heading">
              {{ 'OBJETO' | translate }}
            </div>
            <div class="Rtable-cell cantidad-cell column-heading">
              {{ 'CANT' | translate }}
            </div>
            <div class="Rtable-cell precio-cell column-heading">
              {{ 'TOTAL' | translate }}
            </div>
            <div class="Rtable-cell delete-cell column-heading"></div>
          </div>
        </div>
        <perfect-scrollbar class="detailScroll ps--active-y">
          <!-- <div *ngIf="albaran.AlbaranRecintos.length > 0; else albaranItems"> -->
          <div *ngIf="false; else albaranItems">
            <div
              class="Rtable-row"
              *ngFor="let item of albaran.AlbaranRecintos"
            >
              <div class="Rtable-row-inner">
                <div class="Rtable-cell item-cell">
                  <div
                    *ngIf="item.Espectaculo"
                    class="Rtable-cell--content item-content"
                  >
                    {{ item.Espectaculo }}
                  </div>
                  <div class="resumenDescuentos">
                    <span *ngIf="item.RecintoNombre">{{
                      item.RecintoNombre
                    }}</span>
                    <span *ngIf="item.NumFila && item.NumButaca"
                      >{{ 'FILA' | translateV2 : 'CAPITALIZE' }}:
                      {{ item.NumFila }}
                      {{ 'BUTACA' | translateV2 : 'CAPITALIZE' }}:
                      {{ item.NumButaca }}</span
                    >
                    <span *ngIf="item.FechaEntrada">{{
                      item.FechaEntrada
                    }}</span>
                  </div>
                </div>
                <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                  <div class="Rtable-cell--content cantidad-content">
                    <div class="quantity">
                      <input
                        [disabled]="true"
                        type="number"
                        class="qty text"
                        step="1"
                        min="0"
                        name="quantity"
                        category="CANTIDAD"
                        value="{{ item.Cantidad }}"
                        title="Cantidad"
                        size="4"
                      />
                    </div>
                  </div>
                </div>
                <div class="Rtable-cell precio-cell">
                  <!-- <div class="Rtable-cell--content precio-content">
                    {{
                      conversor(item.PrecioUnidad) * conversor(item.Cantidad)
                        | myCurrency
                          : divisaSimboloDecimal
                          : divisaDecimales
                          : divisaPosicion
                          : divisaSimbolo
                          : divisaSimboloDerecha
                          : divisaSimbSeparacionMiles
                    }}
                  </div> -->

                  <div class="Rtable-cell--content precio-content">
                    {{
                      getPriceByLinea(item.PrecioUnidad, item.Cantidad)
                        | myCurrency
                          : divisaSimboloDecimal
                          : divisaDecimales
                          : divisaPosicion
                          : divisaSimbolo
                          : divisaSimboloDerecha
                          : divisaSimbSeparacionMiles
                    }}
                  </div>
                </div>
                <div class="Rtable-cell delete-cell">
                  <div class="Rtable-cell--content delete-content">
                    <a title="Borrar">
                      <span class="cross"></span>
                      <span class="sr-only"> {{ 'CERRAR' | translateV2 }}</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="resumenDescuentos">
                <span *ngFor="let m of item.motivosAsociados"
                  >* {{ m.ItemNombre }} ({{ m.NumMotivos }})</span
                >
              </div>
              <!-- <div *ngIf="linea.descuentos" class="resumenDescuentos">
                          <span *ngFor="let dto of linea.descuentos">* {{dto.motivoDescuento.Nombre}} <span *ngIf="dto.todos">(TODOS)</span></span>
                        </div> -->
            </div>
          </div>

          <ng-template #albaranItems>
            <div class="Rtable-row" *ngFor="let item of albaran.AlbaranItems">
              <div class="Rtable-row-inner">
                <div class="Rtable-cell item-cell">
                  <div class="Rtable-cell--content item-content">
                    {{ item.NombrePantalla }}
                  </div>
                </div>
                <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                  <div class="Rtable-cell--content cantidad-content">
                    <div class="quantity">
                      <input
                        [disabled]="true"
                        type="number"
                        class="qty text"
                        step="1"
                        min="0"
                        name="quantity"
                        category="CANTIDAD"
                        value="{{ item.Cantidad }}"
                        title="Cantidad"
                        size="4"
                      />
                    </div>
                  </div>
                </div>
                <div class="Rtable-cell precio-cell">
                  <div class="Rtable-cell--content precio-content">
                    <!-- <div class="Rtable-cell--content precio-content">
                      {{
                        conversor(item.PrecioUnidad) * conversor(item.Cantidad)
                          | myCurrency
                            : divisaSimboloDecimal
                            : divisaDecimales
                            : divisaPosicion
                            : divisaSimbolo
                            : divisaSimboloDerecha
                            : divisaSimbSeparacionMiles
                      }}
                    </div> -->
                    <div class="Rtable-cell--content precio-content">
                      {{
                        getPriceByLinea(item.PrecioUnidad, item.Cantidad)
                          | myCurrency
                            : divisaSimboloDecimal
                            : divisaDecimales
                            : divisaPosicion
                            : divisaSimbolo
                            : divisaSimboloDerecha
                            : divisaSimbSeparacionMiles
                      }}
                    </div>
                  </div>
                </div>
                <div class="Rtable-cell delete-cell">
                  <div class="Rtable-cell--content delete-content">
                    <a title="Borrar">
                      <span class="cross"></span>
                      <span class="sr-only">{{ 'CERRAR' | translateV2 }}</span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="resumenDescuentos">
                <span *ngFor="let m of item.motivosAsociados"
                  >* {{ m.ItemNombre }} ({{ m.NumMotivos }})</span
                >
              </div>
              <div *ngIf="item.TipoCentro" class="resumenDescuentos">
                <span
                  >* {{ item.TipoCentro }} {{ item.RangoEdad }}
                  {{ item.Curso }}</span
                >
              </div>
              <!-- <div *ngIf="linea.descuentos" class="resumenDescuentos">
                          <span *ngFor="let dto of linea.descuentos">* {{dto.motivoDescuento.Nombre}} <span *ngIf="dto.todos">(TODOS)</span></span>
                        </div> -->
            </div>
          </ng-template>
        </perfect-scrollbar>
      </div>
    </div>
  </fieldset>
</ng-container>
<div class="NumpadWrap">
  <div class="totales" *ngIf="albaran$ | async as albaran">
    <div class="titulos">
      <span>{{ 'CANTIDAD' | translate }}</span>
      <span>{{ 'TOTAL' | translate }}</span>
    </div>
    <div class="numeros">
      <span>{{ cantidadProductos }}</span>
      <span
        >{{
          albaran.TotalPagar
            | myCurrency
              : divisaSimboloDecimal
              : divisaDecimales
              : divisaPosicion
              : divisaSimbolo
              : divisaSimboloDerecha
              : divisaSimbSeparacionMiles
        }}
      </span>
    </div>
  </div>
  <!-- <ticketing-numpad></ticketing-numpad> -->
  <button type="button" value="PAGAR" class="pagar" disabled *ngIf="false">
    {{ 'PAGAR' | translate }}
  </button>
  <button
    type="button"
    value="DEVOLVER"
    class="pagar"
    (click)="devolver()"
    [disabled]="!habilitarDevolucion || sePuedeFinalizar()"
  >
    {{ 'DEVOLVER' | translate }}
  </button>
</div>
